import { create } from 'zustand';

interface GenerationProgressStore {
  // State
  progress: number;
  currentStep: string;
  error: string | null;
  completedSteps: string[];
  isGenerating: boolean;

  // Actions
  startGeneration: () => void;
  updateProgress: (progress: number) => void;
  setCurrentStep: (step: string) => void;
  completeStep: (step: string) => void;
  setError: (error: string) => void;
  reset: () => void;
}

export const useGenerationProgressStore = create<GenerationProgressStore>((set) => ({
  progress: 0,
  currentStep: '',
  error: null,
  completedSteps: [],
  isGenerating: false,

  startGeneration: () => {
    set({
      progress: 0,
      currentStep: 'Initializing',
      error: null,
      completedSteps: [],
      isGenerating: true
    });
  },

  updateProgress: (progress: number) => {
    set({ progress: Math.min(100, Math.max(0, progress)) });
  },

  setCurrentStep: (step: string) => {
    set({ currentStep: step });
  },

  completeStep: (step: string) => {
    set((state: GenerationProgressStore) => ({
      completedSteps: [...state.completedSteps, step],
      progress: Math.min(100, state.progress + (100 / (state.completedSteps.length + 1)))
    }));
  },

  setError: (error: string) => {
    set({ error, isGenerating: false });
  },

  reset: () => {
    set({
      progress: 0,
      currentStep: '',
      error: null,
      completedSteps: [],
      isGenerating: false
    });
  }
}));
